import axios from './../api' // 倒入 api

//主动安全报警处理
const handleAdasRisk = (asRiskId,params) => {
  return axios({
    url: `/api/as/risk/${asRiskId}`,
    method: 'put',
    params
  })
}

//主动安全报警事件获取
const getAdasEvents = (asRiskId) => {
  return axios({
    url: `/api/as/event/${asRiskId}`,
    method: 'GET',
  })
}

//主动安全报警附件获取
const getRiskAttachment = (asRiskId) => {
  return axios({
    url: `/api/as/risk/attachment/${asRiskId}`,
    method: 'GET',
  })
}

//主动安全报警事件附件获取
const getEventAttachment = (asEventId) => {
  return axios({
    url: `/api/as/event/attachment/${asEventId}`,
    method: 'GET',
  })
}

//主动安全报警事件附件补传
const reUploadAttachment = (params) => {
  return axios({
    url: `/api/as/attachment/download`,
    method: 'GET',
    params
  })
} 

//主动安全TTS播报
const adasTTSPush = (hardwareId,params) => {
  return axios({
    url: `/api/command/text/${hardwareId}`,
    method: 'post',
    params
  })
} 
// /command/text/{hardwareId}

//主动安全打开全部视频
const adasVideoALLOpen = (hardwareId) => {
  return axios({
    url: `/api/command/openAllAvideo/${hardwareId}`,
    method: 'get',
  })
}

export default {
  handleAdasRisk,
  getAdasEvents,
  getRiskAttachment,
  getEventAttachment,
  reUploadAttachment,
  adasTTSPush,
  adasVideoALLOpen
}